import {mc} from './mc';

export const toast = {
  info({message}: {message: string}) {
    mc.send('toast', 'info', {message});
  },
  error(error: {message: string; code?: number}) {
    mc.send('toast', 'error', error);
  },
};
